module.exports = __webpack_public_path__ + "static/media/Onboarding1@1x.d8dc112c.png";